import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_location",
  "use": "icon-project_location-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_location\"><g transform=\"translate(4 1)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><path d=\"M18.545 15.973a9.903 9.903 0 001.938-5.898C20.483 4.51 15.898 0 10.24 0 4.585 0 0 4.51 0 10.074A9.904 9.904 0 001.958 16\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.958 16.026L10.317 26l8.228-10\" /><circle cx=\"10.241\" cy=\"10\" r=\"4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol